import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useContext } from 'react';
import { Context as MobileContext } from '../../Context/IsMobileContext';
import { mobile, Spacings, Fonts } from '../../../styleConstants';
import SectionName from './SectionName/SectionName';
import SectionNameMobile from './SectionName/SectionNameMobile';
// import SummitNavbar from './SummitNavbar/SummitNavbar';
import ContentContainer from './ContentContainer';
import SectionQuote from './SectionTitle';
import SectionDescription from './SectionDescription';

const Wrapper = styled.section`
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: 120px;
  }
`;

const SectionContentWrapper = styled.div`
  margin-top: ${({ $marginTop }) => $marginTop};
  position: relative;
  padding: 0px 115px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    padding: 0px ${Spacings.SPACING_5B};
  }
`;

const SectionInfo = styled.div`
  display: grid;
  grid-template: ${({ $isMobile }) =>
    $isMobile ? 'max-content max-content / 1fr' : '1fr / 3fr 2.5fr'};
  grid-column-gap: 200px;
  grid-row-gap: ${Spacings.SPACING_4B};
  align-items: end;
  @media only screen and (max-width: 1400px) {
    grid-column-gap: 100px;
    align-items: start;
  }
`;

const InnerContentContainer = styled.div`
  margin-top: 120px;
  @media only screen and (max-width: ${mobile.maxWidth}) {
    margin-top: ${Spacings.SPACING_10B};
  }
`;

const SectionContainer = ({
  title,
  color,
  sectionId,
  contentMarginTop,
  children,
  headerRefs,
  quote,
  description,
  hideSectionInfo
}) => {
  const isMobileDevice = useContext(MobileContext);
  const SectionTitle = isMobileDevice ? SectionNameMobile : SectionName;
  return (
    <Wrapper>
      <SectionTitle title={title} color={color} ref={headerRefs[sectionId]} />
      <SectionContentWrapper $marginTop={contentMarginTop}>
        {/* {!isMobileDevice && (
          <SummitNavbar activeSectionId={sectionId} headerRefs={headerRefs} />
        )} */}
        <ContentContainer>
          {!hideSectionInfo && (
            <SectionInfo $isMobile={isMobileDevice}>
              <SectionQuote $size={isMobileDevice ? Fonts.H2 : '80px'}>
                {quote}
              </SectionQuote>
              <SectionDescription $size={isMobileDevice ? Fonts.H5 : Fonts.H3}>
                {description}
              </SectionDescription>
            </SectionInfo>
          )}
          <InnerContentContainer>{children}</InnerContentContainer>
        </ContentContainer>
      </SectionContentWrapper>
    </Wrapper>
  );
};

SectionContainer.propTypes = {
  title: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  sectionId: PropTypes.string.isRequired,
  contentMarginTop: PropTypes.string,
  children: PropTypes.node,
  headerRefs: PropTypes.objectOf(PropTypes.object).isRequired,
  quote: PropTypes.string,
  description: PropTypes.string,
  hideSectionInfo: PropTypes.bool
};

SectionContainer.defaultProps = {
  contentMarginTop: '120px',
  children: null,
  quote: '',
  description: '',
  hideSectionInfo: false
};

export default SectionContainer;
